import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Aside from "../../components/Aside";
import Api from "../../services/api";
import swal from "sweetalert";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import EditDestino from "./edit";
import NewBanner from "./new";
import ReactTooltip from "react-tooltip";

const DESTINO_LABELS = {
  ilhabela: "Ilhabela / SP",
  paraty: "Paraty e Ilha Grande / RJ",
  main: "Banner Principal",
};

const SECTION_LABELS = {
  cards: "Card de Destino",
  topo: "Banner do Topo",
};

const IDIOMA_LABELS = {
  pt: "Português",
  en: "Inglês",
  es: "Espanhol",
};

export default function DestinosHome() {
  const [loading, setLoading] = useState(true);
  const Loader = () => <div className="loading"></div>;
  const [destinos, setDestinos] = useState([]);
  const [openModalNew, setOpenModalNew] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [destinoEdit, setDestinoEdit] = useState(null);

  useEffect(() => {
    loadDestinos();
  }, []);

  function loadDestinos() {
    setLoading(true);
    Api.get("/destinoshome/list")
      .then((response) => {
        setDestinos(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
        setLoading(false);
      });
  }

  function editItem(item) {
    setDestinoEdit(item);
    setOpenModalEdit(true);
  }

  function deleteItem(item) {
    swal({
      title: "Excluir Banner",
      text: "Deseja realmente excluir esse banner?",
      icon: "warning",
      buttons: ["Cancelar", "Excluir"],
      dangerMode: true,
    }).then((willDelete) => {
      if (!willDelete) return;
      setLoading(true);
      Api.delete("/destinoshome/delete/" + item.id)
        .then((response) => {
          swal(response.data.message, { icon: "success" });
          loadDestinos();
        })
        .catch((err) => {
          swal("ops! ocorreu um erro: " + err, { icon: "error" });
          setLoading(false);
        });
    });
  }

  const RenderContent = () => {
    useEffect(() => {
      ReactTooltip.rebuild();
    });

    const rows = destinos.map((item, index) => {
      const imagem = () =>
        item.imagem && (
          <img
            src={process.env.REACT_APP_FILES_URL + item.imagem}
            style={{ maxWidth: "100%", height: "100px" }}
            alt=""
          />
        );

      return (
        <div className="item" key={index}>
          <div>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                editItem(item);
              }}
              data-tip="Editar"
            >
              <i className="bx bx-edit"></i>
            </a>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                deleteItem(item);
              }}
              data-tip="Excluir"
            >
              <i className="bx bx-trash"></i>
            </a>
          </div>
          <div>{SECTION_LABELS[item.section] || item.section}</div>
          <div>{DESTINO_LABELS[item.destino] || item.destino}</div>
          <div>{IDIOMA_LABELS[item.idioma] || item.idioma}</div>
          <div>{item.ordem}</div>
          <div>{imagem()}</div>
        </div>
      );
    });

    return (
      <div className="grid">
        <div className="header">
          <div></div>
          <div>Seção</div>
          <div>Destino</div>
          <div>Idioma</div>
          <div>Ordem</div>
          <div>Imagem</div>
        </div>
        <div className="content">{rows}</div>
      </div>
    );
  };

  function renderTopPage() {
    return (
      <div className="top">
        <div>
          <span className="text">Banners da Home</span>
          <ul className="breadcrumbs">
            <li>Página Inicial</li>
            <li>Banners da Home</li>
          </ul>
        </div>
        <div>
          <div className="actions top">
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                setOpenModalNew(true);
              }}
            >
              <i className="bx bx-plus-circle"></i> Novo Banner
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {loading ? <Loader /> : null}
      <ReactTooltip effect="solid" />
      <div className="container-box">
        <Aside />
        <main>
          {renderTopPage()}
          {destinos && RenderContent()}
        </main>

        <Modal
          open={openModalNew}
          onClose={() => setOpenModalNew(false)}
          classNames={{
            overlay: "customOverlay",
            modal: "customModal",
          }}
        >
          <NewBanner
            loadDestinos={loadDestinos}
            setOpenModalNew={setOpenModalNew}
          />
        </Modal>

        <Modal
          open={openModalEdit}
          onClose={() => setOpenModalEdit(false)}
          classNames={{
            overlay: "customOverlay",
            modal: "customModal",
          }}
        >
          {destinoEdit && (
            <EditDestino
              data={destinoEdit}
              loadDestinos={loadDestinos}
              setOpenModalEdit={setOpenModalEdit}
            />
          )}
        </Modal>
      </div>
    </>
  );
}
